const CUSTOM_ASSETS_BASE = "assets/images/instructions/custom";

export const PAGE_IDS = [
 "m001",
 "m002",
 "m003",
 "m004",
 "m005",
 "m006",
 "m007",
 "m008",
 "m009",
 "m010",
 "m011",
 "m012",
 "m013",
 "m014",
 "m015",
 "m016",
];

export const MISSION_ZERO_PAGE_COUNT = PAGE_IDS.length;

export const OVERLAY_SIZE_PRESETS = {
 sm: { overlayLeftPercent: 51, overlayTopPercent: 89 },
 md: { overlayLeftPercent: 53, overlayTopPercent: 89.5 },
 lg: { overlayLeftPercent: 57, overlayTopPercent: 89.5 },
};

// Overlay coordinates are defaults/fallbacks for the nav hint.
// When a page has a bubble, the instructions plugin anchors the nav hint to that bubble.
export const OVERLAY_BY_PAGE = {
 m001: {
  overlayPreset: "md",
  overlayLeftPercent: 49,
  showBackKey: false,
  bubbleMaxWidthPercent: 38,
 },
 m002: { overlayPreset: "sm" },
 m003: { overlayPreset: "sm" },
 m004: { overlayPreset: "sm" },
 m005: { overlayPreset: "lg", showBackKey: false },
 m006: { overlayPreset: "lg" },
 m007: { overlayPreset: "sm" },
 m008: { overlayPreset: "sm" },
 m009: { overlayPreset: "lg", showBackKey: false },
 m010: { overlayPreset: "md" },
 m011: { overlayPreset: "sm" },
 m012: { overlayPreset: "sm" },
 m013: { overlayPreset: "sm" },
 m014: { overlayLeftPercent: 61, overlayTopPercent: 89.5, showBackKey: false },
 m015: { overlayPreset: "md" },
 m016: { overlayPreset: "sm" },
};

export const DEFAULT_PAGE_UI = {
 showPilot: false,
};

export const PAGE_UI_BY_PAGE = {
 m001: { showPilot: true },
};

export const BUBBLE_DEFAULT_LAYOUT = {
 wrapperLeftPercent: 32.5,
 wrapperBottomPercent: 8,
 minWidthPercent: 36,
 maxWidthPercent: 52,
 fontSizeVw: 0.85,
 padding: "0.9vw 1.2vw 2.4vw 1.2vw",
 tailBottomVw: -1.5,
 tailLeftVw: -1.5,
 tailWidthVw: 9.4,
 tailHeightVw: 2.5,
};

export const PILOT_LAYOUT_ADJUSTMENTS = {
 bubbleMaxWidthPercent: 38,
 overlayLeftOffsetPercent: -4,
};

export const FELLOW_EMOTION_SOURCES = {
 "hq-happy": `${CUSTOM_ASSETS_BASE}/hq-happy.svg`,
 "hq-impressed": `${CUSTOM_ASSETS_BASE}/hq-impressed.svg`,
 "hq-neutral": `${CUSTOM_ASSETS_BASE}/hq-neutral.svg`,
 "hq-speaking": `${CUSTOM_ASSETS_BASE}/hq-speaking.svg`,
};

export const MISSION_ZERO_BACKGROUND_SRC = `${CUSTOM_ASSETS_BASE}/background.svg`;
export const MISSION_ZERO_PILOT_SRC = `${CUSTOM_ASSETS_BASE}/driver.svg`;
